export default "__VITE_ASSET__qGYo26jm__"